import { render, staticRenderFns } from "./SettingFormModal.vue?vue&type=template&id=2fe21599&"
import script from "./SettingFormModal.ts?vue&type=script&lang=js&"
export * from "./SettingFormModal.ts?vue&type=script&lang=js&"
import style0 from "./SettingFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports